/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => {
        item.addEventListener('change', this.debouncedOnSubmit.bind(this));
      });
      this.initLanguageFlagsDropdown();
      this.initCountryFlagsDropdown();
      this.classList.remove('thb-localization-forms--pending');
      this.classList.add('thb-localization-forms--js-ready');
    }
    initCountryFlagsDropdown() {
      const dropdown = this.querySelector('.thb-country-flags-dropdown');
      if (!dropdown) return;
      const trigger = dropdown.querySelector('.thb-country-flags-trigger');
      const list = dropdown.querySelector('.thb-country-flags-list');
      const select = dropdown.querySelector('select[name="country_code"]');
      if (!trigger || !list || !select) return;

      const close = () => {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', closeOnClickOutside);
      };
      const closeOnClickOutside = (e) => {
        if (!dropdown.contains(e.target)) close();
      };

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        if (list.hidden) {
          list.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          setTimeout(() => document.addEventListener('click', closeOnClickOutside), 0);
        } else close();
      });

      list.querySelectorAll('.thb-country-flags-option').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const countryCode = btn.getAttribute('data-country');
          if (countryCode && select.value !== countryCode) {
            select.value = countryCode;
            const newFlag = btn.querySelector('.thb-country-flag-img');
            const currentSpan = trigger.querySelector('.thb-country-flags-current');
            if (currentSpan && newFlag && newFlag.cloneNode) {
              currentSpan.innerHTML = '';
              currentSpan.appendChild(newFlag.cloneNode(true));
            }
            list.querySelectorAll('.thb-country-flags-option').forEach(o => {
              o.classList.toggle('is-selected', o === btn);
              o.setAttribute('aria-selected', o === btn ? 'true' : 'false');
            });
            close();
            if (this.form) this.form.submit();
          }
        });
      });
    }
    initLanguageFlagsDropdown() {
      const wrap = this.querySelector('.kap-lang-wrap');
      if (!wrap) return;
      const btn = wrap.querySelector('.kap-lang-btn');
      const menu = wrap.querySelector('.kap-lang-menu');
      const select = wrap.querySelector('select.kap-lang-hidden');
      const form = wrap.closest('form');
      if (!btn || !menu || !select) return;

      // Forcer le drapeau affiché selon l’URL (contourne le cache Liquid)
      const path = (typeof window !== 'undefined' && window.location && window.location.pathname) ? window.location.pathname : '';
      const segment = (path.split('/').filter(Boolean)[0] || '').toLowerCase();
      const options = Array.from(select.options).map(function(o) { return o.value; });
      let urlLocale = options[0] || 'fr';
      if (segment) {
        const segmentLang = segment.split('-')[0];
        const segmentRegion = segment.split('-').slice(1).join('-');
        const exact = options.find(function(o) { return o.toLowerCase() === segment; });
        const byLang = options.filter(function(o) {
          const oLang = o.toLowerCase().split('-')[0];
          return oLang === segmentLang;
        });
        if (exact) {
          urlLocale = exact;
        } else if (byLang.length) {
          var withRegion = byLang.find(function(o) {
            const oLower = o.toLowerCase();
            const oParts = oLower.split('-');
            return oParts.length > 1 && oParts.slice(1).join('-') === segmentRegion;
          });
          urlLocale = withRegion || byLang[0];
        } else {
          const fallback = options.find(function(o) {
            const oLower = o.toLowerCase();
            return oLower === segment || oLower.indexOf(segment + '-') === 0 || oLower.split('-')[0] === segment;
          });
          if (fallback) urlLocale = fallback;
        }
      }
      if (select.value !== urlLocale) {
        select.value = urlLocale;
      }
      // Toujours synchroniser le drapeau affiché avec la locale déduite de l’URL
      const item = Array.from(menu.querySelectorAll('.kap-lang-item')).find(function(el) {
        return el.getAttribute('data-locale') && el.getAttribute('data-locale').toLowerCase() === urlLocale.toLowerCase();
      });
      const current = wrap.querySelector('.kap-lang-current');
      if (item && current) {
        const img = item.querySelector('img');
        if (img) {
          current.innerHTML = '';
          current.appendChild(img.cloneNode(true));
        }
        menu.querySelectorAll('.kap-lang-item').forEach(function(o) {
          var loc = o.getAttribute('data-locale');
          o.classList.toggle('kap-lang-item--active', loc && loc.toLowerCase() === urlLocale.toLowerCase());
        });
      }

      function openMenu() {
        menu.classList.add('kap-lang-menu--open');
        menu.hidden = false;
        menu.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        setTimeout(function() {
          document.addEventListener('click', onDocumentClick);
        }, 10);
      }
      function closeMenu() {
        menu.classList.remove('kap-lang-menu--open');
        menu.hidden = true;
        menu.setAttribute('aria-hidden', 'true');
        btn.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', onDocumentClick);
      }
      function onDocumentClick(e) {
        if (!wrap.contains(e.target)) closeMenu();
      }

      closeMenu();

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (menu.classList.contains('kap-lang-menu--open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      menu.querySelectorAll('.kap-lang-item').forEach(function(item) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var locale = item.getAttribute('data-locale');
          if (!locale) return;
          var current = wrap.querySelector('.kap-lang-current');
          var img = item.querySelector('img');
          if (current && img) {
            current.innerHTML = '';
            current.appendChild(img.cloneNode(true));
          }
          menu.querySelectorAll('.kap-lang-item').forEach(function(o) {
            o.classList.toggle('kap-lang-item--active', o === item);
          });
          closeMenu();
          if (select.value !== locale) {
            select.value = locale;
            if (form) form.submit();
          }
        });
      });
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}